import { FunctionComponent } from "react";
import "./VirtualClassHeader.scss";
import images from "../../assets/images";

const VirtualClassHeader: FunctionComponent = () => {
  const { katonHeaderLogoVirtual } = images;

  return (
    <section className="VirtualClassHeader">
      <div className="headercontainer">
        <img className="hdrLogoIcon" alt="logoImage" src={katonHeaderLogoVirtual} />
      </div>
    </section>
  );
};

export default VirtualClassHeader;
